import { Box, ButtonNew as Button, ModalDialogNew, Spacer, Text, TextProps } from '@jfs/ui-new'
import { Icon } from '@jfs/ui-new/src/comps/IconNew'
import { Screens } from '../../nav/Screens'
import { nativeJSComm, nativeJSMapper } from '../../util/WebFns'
import { Title } from '../Title'

interface ErrorDialogProps {
  show: boolean
  message: string
  type: 'CLOSE_WEBVIEW' | 'POSITIVE' | 'NEGATIVE' | 'LINK_ADDHAAR_ERROR'
  resetErrorDialog: any
  navigationRef: any
}

export const ErrorDialog = ({ show, message, type, resetErrorDialog, navigationRef }: ErrorDialogProps) => {
  return (
    <ModalDialogNew type={'bottom'} show={show} backgroundColor="TRANSPARENT">
      <Box
        flexDirection={'column'}
        ph={48}
        pt={48}
        pb={8}
        borderTopLeftRadius={24}
        borderTopRightRadius={24}
        alignItems={'center'}
        backgroundColor={'WHITE'}>
        <Box
          width={32}
          height={32}
          borderRadius={32}
          backgroundColor={type === 'POSITIVE' ? 'BRAND_PRIMARY_GREEN' : 'BRAND_PRIMARY_RED'}
          justifyContent="center"
          alignItems={'center'}>
          <Icon id="CLOSE" size={20} color={'WHITE'} />
        </Box>
        <Spacer size={24} />
        <Title title={message} color="BLACK_75" />
        <Spacer size={8} />
        <Button
          type={'secondary'}
          onPress={() => {
            if (type === 'POSITIVE' || type === 'NEGATIVE') {
              resetErrorDialog()
            } else if (type === 'CLOSE_WEBVIEW') {
              nativeJSComm(nativeJSMapper.closeWebView)
            } else if (type === 'LINK_ADDHAAR_ERROR') {
              resetErrorDialog()
              navigationRef?.current?.goBack()
              navigationRef?.current?.goBack()
              navigationRef?.current?.goBack()
            } else if (type === 'RESET_TO_DMR_HOME') {
              resetErrorDialog()
              navigationRef?.current.reset({
                index: 1,
                routes: [
                  { name: Screens.DOMESTIC_MONEY_TRANSFER_HOME_SCREEN as never },
                  {
                    name: Screens.DOMESTIC_MONEY_TRANSFER_LOGIN as never,
                  },
                ],
              })
            }
          }}
          borderColor={'TRANSPARENT'}
          underlayColor={'TRANSPARENT'}
          children={
            <Text
              {...styles.secondaryButtonText}
              color={type === 'POSITIVE' ? 'BRAND_PRIMARY_GREEN' : 'BRAND_PRIMARY_RED'}>
              OK
            </Text>
          }
        />
      </Box>
    </ModalDialogNew>
  )
}

const styles = {
  secondaryButtonText: {
    fontSize: 14,
    fontFamily: 'jioType-medium',
    color: 'BRAND_PRIMARY_RED',
  } as TextProps,
}
